import { render, staticRenderFns } from "./invreceievein.vue?vue&type=template&id=8d9b4454&scoped=true&"
import script from "./invreceievein.vue?vue&type=script&lang=js&"
export * from "./invreceievein.vue?vue&type=script&lang=js&"
import style0 from "./invreceievein.vue?vue&type=style&index=0&id=8d9b4454&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9b4454",
  null
  
)

export default component.exports